export class Product {
   constructor(product_id, product_name, product_description, product_type, product_cost, product_subsidiary_cost, product_time_minutes){
      this.product_id = product_id
      this.product_name = product_name
      this.product_description = product_description
      this.product_type = product_type
      this.product_cost = product_cost
      this.product_subsidiary_cost = product_subsidiary_cost
      this.product_time_minutes = product_time_minutes
   }

   static fromServiceProductsBySubsidiary (product) {
      return new Product(
         product.product_id,
         product.product_name,
         product.product_description,
         product.product_type,
         product.product_cost,
         product.product_subsidiary_cost,
         product.product_time_minutes
         );
   }   
}